// Viewer-only lightweight modal — non-commercial tender detail:
// reference, project, client, status, address, W3W, scope of works.
// No editable inputs, no financial fields, no other views.
import React from 'react';

export default function TenderInfoModal({ tender, onClose }) {
  if (!tender) return null;
  const addr = tender.site_address;
  const w3w  = tender.what3words;
  const scope = tender.initial_notes || tender.notes;

  const label = { fontSize:10, color:'#64748b', fontWeight:600, textTransform:'uppercase', letterSpacing:'0.06em', marginBottom:4 };
  const box   = { color:'#e2e8f0', fontSize:13, background:'#0f172a', padding:'8px 10px', borderRadius:5, border:'1px solid #334155', whiteSpace:'pre-wrap', lineHeight:1.4, fontFamily:'inherit' };
  const boxMono = { ...box, fontFamily:"'DM Mono', monospace" };
  const missing = { color:'#475569', fontStyle:'italic' };

  return (
    <div style={{ position:'fixed', inset:0, background:'rgba(0,0,0,0.6)', zIndex:1000, display:'flex', alignItems:'center', justifyContent:'center' }} onClick={onClose}>
      <div style={{ background:'#1e293b', border:'1px solid #334155', borderRadius:10, padding:24, width:520, maxWidth:'90vw', maxHeight:'85vh', overflowY:'auto' }}
           onClick={e => e.stopPropagation()}>
        <div style={{ display:'flex', justifyContent:'space-between', alignItems:'flex-start', marginBottom:12 }}>
          <div>
            <h3 style={{ margin:'0 0 4px', color:'#f1f5f9', fontSize:15 }}>{tender.project_ref || '—'}</h3>
            <div style={{ color:'#94a3b8', fontSize:12 }}>{tender.project_name || tender.title || '—'}</div>
          </div>
          <span style={{ fontSize:10, color:'#64748b', fontWeight:600, textTransform:'uppercase', letterSpacing:'0.06em', padding:'2px 7px', border:'1px solid #334155', borderRadius:4 }}>
            {tender.status || '—'}
          </span>
        </div>
        <div style={{ height:1, background:'#334155', margin:'12px 0 16px' }} />

        <div style={{ marginBottom:14 }}>
          <div style={label}>Client</div>
          <div style={box}>{tender.client || <span style={missing}>Not recorded</span>}</div>
        </div>

        <div style={{ marginBottom:14 }}>
          <div style={label}>Site Address</div>
          <div style={box}>{addr || <span style={missing}>Not recorded</span>}</div>
        </div>

        <div style={{ marginBottom:14 }}>
          <div style={label}>What3Words</div>
          <div style={{ ...boxMono, color: w3w ? '#10b981' : '#475569' }}>
            {w3w ? '///' + w3w : <span style={missing}>Not recorded</span>}
          </div>
        </div>

        <div style={{ marginBottom:14 }}>
          <div style={label}>Scope of Works</div>
          <div style={box}>{scope || <span style={missing}>Not recorded</span>}</div>
        </div>

        <div style={{ display:'flex', justifyContent:'flex-end', marginTop:16 }}>
          <button onClick={onClose} style={{ padding:'7px 16px', borderRadius:6, border:'1px solid #334155', background:'transparent', color:'#94a3b8', cursor:'pointer', fontSize:13 }}>Close</button>
        </div>
        <div style={{ marginTop:12, fontSize:10, color:'#475569', textAlign:'center' }}>Read-only view — non-commercial context only.</div>
      </div>
    </div>
  );
}
